<template>
  <avs-card class="pb-4">
    <template v-slot:title>
      <v-toolbar
        class="mt-4 custom-toolbar"
        elevation="0"
      >
        <v-text-field
          clearable
          hide-details
          prepend-inner-icon="mdi-magnify"
          :label="$t('commons.search')"
          v-model="search"
      /></v-toolbar>
    </template>
    <template v-slot:content>
      <v-data-table
        class="ma-10"
        :no-data-text="$t('messages.information.no_data')"
        :headers="headers"
        :items="nonConformities"
        :search="search"
        item-text="text"
        :loading-text="$t('categories.nonconformity.loading')"
        :no-results-text="$tc('categories.nonconformity.name', 0)"
        :loading="loading"
        disable-pagination
        hide-default-footer
        @dblclick:row="($event, { item }) => handleNonConformityEdit(item)"
      >
        <template v-slot:item.report_date="{ item }">
          {{ toDatetime(item.report_date) }}
        </template>
        <template v-slot:item.status="{ item }">
          <component :is="handleStatusComponent(item)" />
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="d-flex justify-end">
            <avs-editButton
              @click.stop="handleNonConformityEdit(item)"
              :spantext="
                $t('actions.edit', {
                  entity: $tc('categories.nonconformity.name', 1).toLowerCase()
                })
              "
            />
            <avs-deleteButton
              @click.stop="handleOpenDeleteDialog(item)"
              :spantext="
                $t('actions.delete', {
                  entity: $tc('categories.nonconformity.name', 1).toLowerCase()
                })
              "
            />
          </div>
        </template>
      </v-data-table>
      <avs-deleteDialog
        v-model="deleteDialogIsOpen"
        @cancel="handleCancel"
        @delete="handleDelete"
        resource="nonconformity"
      />
    </template>
  </avs-card>
</template>

<script>
import { Closed, Ongoing, Overdue, Pending } from "@/components/generics/status"
import { NonConformityService, ProjectService } from "@/services"
import { toDatetime } from "@/utils/datetime"

export default {
  name: "AllNonConformities",
  components: { Closed, Ongoing, Overdue, Pending },
  data() {
    return {
      deleteDialogIsOpen: false,
      headers: [
        { text: "Company", value: "company.name", class: "min-width-200" },
        { text: "Project", value: "project.name", class: "min-width-200" },
        { text: "Report date", value: "report_date", class: "min-width-150" },
        { text: "Area", value: "area" },
        { text: "Event", value: "event" },
        { text: "RCA", sortable: false, value: "rca" },
        { text: "Status", align: "center", value: "status" },
        { text: "Actions", sortable: false, value: "actions", align: "right", width: 100 }
      ],
      nonConformities: [],
      loading: false,
      search: "",
      selectedItem: null
    }
  },
  created() {
    this.getAllNonConformities()
  },
  methods: {
    getAllNonConformities() {
      this.loading = true
      NonConformityService.getAllNonConformities().then(response => {
        this.nonConformities = response
        this.loading = false
      })
    },
    handleStatusComponent(item) {
      return item.status
    },
    async setStoreFromProjectId(projectId) {
      return ProjectService.get(this, null, projectId).then(project => {
        this.$store.commit("app/setCompany", project.company)
        this.$store.commit("app/setProject", project)
      })
    },
    async handleNonConformityEdit(item) {
      this.setStoreFromProjectId(item.project.id).then(() => {
        this.$router.push({ name: "NonConformityCreateUpdate", params: { id: item.id } })
      })
    },
    handleOpenDeleteDialog(item) {
      this.deleteDialogIsOpen = true
      this.selectedItem = item
    },
    handleCancel() {
      this.deleteDialogIsOpen = false
    },
    handleDelete(item) {
      NonConformityService.remove(this, this.selectedItem.id).then(r => {
        this.nonConformities = this.nonConformities.filter(nc => nc.id !== this.selectedItem.id)
        this.$store.commit("app/message", {
          msg: this.$t("messages.success.deleted", {
            entity: this.$tc("categories.nonconformity.name", 1)
          }),
          color: "success"
        })
      })
      this.deleteDialogIsOpen = false
    },
    toDatetime
  }
}
</script>
